import { AxiosResponse } from 'axios';
import { axiosInstance } from '../../helpers/api_helper';

export interface AboutSectionTwo {
    id: number;
    pageID: string;
    pageName: string;
    pageContent: string;
    createdBy: string;
    updatedBy: string;
    updated: string;
    createdAt: string;
    pageStatus: number;
}

async function getAboutSectionTwo(): Promise<AboutSectionTwo | undefined> {
    const apiUrl = '/FrontPage/Page/e859ad1d-2364-4415-9841-009ed73c6fd9';

    try {
        const response: AxiosResponse<{ data: AboutSectionTwo }> = await axiosInstance.get(apiUrl);

        // Log the entire response data
        console.log('About Us Page Response Data:', response.data);

        // Extract and return the about us page information
        return response.data.data;
    } catch (error: any) {
        console.error('Error fetching About Us page:', error.message);
        // Handle errors here
        throw error;
    }
}

export { getAboutSectionTwo };
